import {alert} from '../../src/alerts';
import {checkEmail} from '../../src/validation';

var $form = $('.contact__form');

var predupregden = false;

$('#contact__form-text').focus(function () {
    if (!predupregden) {
        predupregden = true;

        // Внимание! Очень часто нам на почту приходят вопросы следующего характера...
        alert(trans('contacts.alert'), trans('contacts.alert_caption'));
    }
});

$('.contact__form-btn').on('click', function () {
    var name = $.trim($('#name').val());
    var email = $.trim($('#email').val());
    var thema = $.trim($('#thema').val());
    var text = $.trim($('#contact__form-text').val());
    var error = false;

    if (!checkEmail(email)) {
        error = true;
    }

    if (false === error && name.length < 2) {
        // Имя не может быть короче 2х символов
        alert(trans('contacts.form_name_short'), trans('contacts.form_name_short_caption'));
        error = true;
    }

    if (false === error && thema.length < 5) {
        // Тема письма не может быть короче 5ти символов
        alert(trans('contacts.form_subject_short'), trans('contacts.form_subject_short_caption'));
        error = true;
    }

    if (false === error && text.length < 20) {
        // Текст письма не может быть короче 20ти символов
        alert(trans('contacts.form_text_short'), trans('contacts.form_text_short_caption'));
        error = true;
    } else {
        $form.find('[name="text"]').val(text);
    }

    if (false === error) {
        $('#sendMailBlock').show();

        $.ajax({
            url: '/send/mail/',
            data: $form.serialize(),
            type: $form.attr('method'),
            success: function (response) {
                if (response.status === 'success') {
                    $('#mailSend').show();
                    $('#mailForm').hide();
                } else {
                    // Произошла ошибка
                    alert(trans('contacts.form_error'));
                }

                $('#sendMailBlock').hide();
            },
        });
    }
});
